import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "aero:file:text-foreground aero:placeholder:text-muted-foreground aero:selection:bg-brand-primary aero:selection:text-brand-primary-foreground aero:dark:bg-input/30 aero:border-input aero:flex aero:h-9 aero:w-full aero:min-w-0 aero:!rounded-md aero:border aero:bg-transparent aero:px-3 aero:py-1 aero:text-base aero:shadow-xs aero:transition-[color,box-shadow] aero:outline-none aero:file:inline-flex aero:file:h-7 aero:file:border-0 aero:file:bg-transparent aero:file:text-sm aero:file:font-medium aero:disabled:pointer-events-none aero:disabled:cursor-not-allowed aero:disabled:opacity-50 aero:md:text-sm",
        "aero:focus-visible:border-ring aero:focus-visible:ring-ring/50 aero:focus-visible:ring-[3px]",
        "aero:aria-invalid:ring-destructive/20 aero:dark:aria-invalid:ring-destructive/40 aero:aria-invalid:border-destructive",
        className
      )}
      {...props}
    />
  );
}

export { Input };
